/**
 * @owner @Appboy/core-objects
 */
import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsTypeNameSchemaFields = "/data_objects/:type_name/schema/fields" as const;

/** Invalidate the fields list GET cache after create/update/delete mutations on this resource. */
export const customObjectsTypeNameSchemaFieldsCacheKeys: AllRouteEndpoints[] = [customObjectsTypeNameSchemaFields];
